export default __webpack_public_path__ + "static/media/slider2.9ed0d7b8.svg";